export const CO6_BPM_SUBMIT = 'CO6_BPM_SUBMIT';
export const GIFTING_SCALE_TOGGLE_V2 = 'CWP_GIFTING_SCALE_V2';
export const GIFTING_INDV_STP_TOGGLE = 'CWP_VG_INDV_GIFTING_STP';
export const GIFTING_JOINT_STP_TOGGLE = 'CWP_VG_JOINT_GIFTING_STP';
export const GIFTING_TRUST_STP_TOGGLE = 'CWP_VG_TRUST_GIFTING_STP';
export const CWP_IRA_SCALE_TRAD = 'CWP_IRA_SCALE_TRAD';
export const CWP_IRA_SCALE_INH_ROTH = 'CWP_IRA_SCALE_INH_ROTH';
export const INHERITANCE_ESTATE_SCALE_TOGGLE = 'CWP_IRA_SCALE_ESTATE';
export const CWP_ESTATE_INDIVIDUAL_TO_STP = 'CWP_ESTATE_INDIVIDUAL_TO_STP';
export const CWP_IRA_SCALE_TRUST = 'CWP_IRA_SCALE_TRUST';
export const CWP_IRA_SCALE_TRUST_TO_TRUST = 'CWP_IRA_SCALE_TRUST_TO_TRUST';
export const CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS = 'CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS';
export const INTELLEDOX_REDIRECT_AND_THRESHOLDS = 'INTELLEDOX_REDIRECT_AND_THRESHOLDS';
export const JOINT_INHERITANCE = 'JOINT_INHERITANCE';
export const INHERITANCE_IRA = 'INHERITANCE_IRA';
export const INHERITANCE_INDIVIDUAL = 'INHERITANCE_INDIVIDUAL';
export const DOC_CHECKLIST_INHERITANCE = 'DOC_CHECKLIST_INHERITANCE';
export const CWP_MULTI_INHERITANCE = 'CWP_MULTI_INHERITANCE';
export const CWP_CO0_MINOR = 'CWP_CO0_MINOR';
export const CWP_CO0_INHERITANCE = 'CWP_CO0_INHERITANCE';
export const CWP_CO0_INTERNAL_TRANSFERS = 'CWP_CO0_INTERNAL_TRANSFERS';
export const CWP_CO0_UPLOAD = 'CWP_CO0_UPLOAD';
export const CWP_CO0_GIFTING = 'CWP_CO0_GIFTING';
export const CWP_DIVORCE = 'CWP_DIVORCE';
export const CWP_INHERITANCE_HIDE_SINGLE_FLOW = 'CWP_INHERITANCE_HIDE_SINGLE_FLOW';
export const CWP_INHERITANCE_IRA_QUESTION = 'CWP_INHERITANCE_IRA_QUESTION';
export const CWP_GIFTING_ADVISED_ACCOUNTS = 'CWP_GIFTING_ADVISED_ACCOUNTS';
export const CWP_IT_MULTI_RECEIVING = 'CWP_IT_MULTI_RECEIVING';
export const CWP_MULTI_TRANSACTIONS_CREW = 'CWP_MULTI_TRANSACTIONS_CREW_TOGGLE';
export const CWP_ACCOUNT_VALIDATION = 'CWP_ACCOUNT_VALIDATION';
export const CWP_MULTI_INHERITANCE_ESTATE = 'CWP_MULTI_INHERITANCE_ESTATE';
export const CWP_INHERITANCE_SAVE_DRAFT = 'CWP_INHERITANCE_SAVE_DRAFT';
export const CWP_INHERITANCE_SAVE_DRAFT_INTERNAL = 'CWP_INHERITANCE_SAVE_DRAFT_INTERNAL';
export const CWP_INHERITANCE_VCD = 'CWP_INHERITANCE_VCD';
export const CWP_PROSPECT_TO_AUTH_FIRST = 'CWP_PROSPECT_TO_AUTH_FIRST';
export const L8_ITW_UPLOAD = 'L8_ITW_UPLOAD';
export const CWP_VC_ORG_TO_ORG = 'CWP_VC_ORG_TO_ORG';
export const CWP_NON_VC_ORG_TRANSFER = 'CWP_NON_VC_ORG_TRANSFER';
export const CWP_DOCUMENT_UPLOAD_MFE = 'CWP_DOCUMENT_UPLOAD_MFE';
export const CWP_INHERITANCE_ORG_AS_BENE = 'CWP_INHERITANCE_ORG_AS_BENE';
export const CWP_MO_GIFTING = 'CWP_MO_GIFTING';
export const CWP_INHERITANCE_INDIVIDUAL_JOINT_TO_TRUST =
  'CWP_INHERITANCE_INDIVIDUAL_JOINT_TO_TRUST';
export const CWP_INHERITANCE_RESTRICT_DUP_TRANSACTIONS =
  'CWP_INHERITANCE_RESTRICT_DUP_TRANSACTIONS';
export const CWP_INHERITANCE_DECEDENT_SECURITY = 'CWP_INHERITANCE_DECEDENT_SECURITY';
export const CWP_INHERITANCE_CHECKLIST_GET_STARTED = 'CWP_INHERITANCE_CHECKLIST_GET_STARTED';
export const CWP_TERMS_W9_REDESIGN = 'CWP_TERMS_W9_REDESIGN';
export const CWP_MULTI_IT_MO = 'CWP_MULTI_IT_MO';
export const CWP_INHERITANCE_ADVISED_CLIENT_WARNINGS = 'CWP_INHERITANCE_ADVISED_CLIENT_WARNINGS';
export const CWP_INHERITANCE_SAVE_STATE = 'CWP_INHERITANCE_SAVE_STATE';
export const CWP_INHERITANCE_NEW_TERMS = 'CWP_INHERITANCE_NEW_TERMS';
export const CWP_MINOR_SAVE_DRAFT = 'CWP_MINOR_SAVE_DRAFT';
export const CWP_CASH_PLUS_SWEEP_TRANSFER = 'CWP_CASH_PLUS_SWEEP_TRANSFER';
export const CWP_BUY_SELL_HOME_URL_ROUTING = 'CWP_BUY_SELL_HOME_URL_ROUTING';
export const CWP_VIADOC_SHADOW_MODE = 'CWP_VIADOC_SHADOW_MODE';
